import { render, staticRenderFns } from "./adminLock.vue?vue&type=template&id=73dcff24"
import script from "./adminLock.vue?vue&type=script&lang=js"
export * from "./adminLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports